module.exports = __webpack_public_path__ + "img/inatall-gbwhatsapp-steps.477a77ee.webp";